<ion-app>
  <ion-split-pane contentId="main-content" when="md" class="split-pane-side">
    <!-- Side Menu -->
    <ion-menu id="t2-side-menu" contentId="main-content" type="overlay" menuId="main-menu" class="split-pane-side" *ngIf="!utils.embedded">
      <ion-header>
        <ion-toolbar>
          <div id="t2-logo-img" class="t2-link-style" (click)="openUrl(utils.homeUrl)"></div>
        </ion-toolbar>
      </ion-header>

      <ion-content class="ion-padding">
        <ion-list lines="none">
          <!-- Custom Logo -->
          <div class="t2-cust-logo" *ngIf="teamData.logoUrl && !teamData.isPartnerSet()">
            <div [style.background-image]="'url(' + teamData.logoUrl + ')'"></div>
          </div>

          <div class="t2-cust-logo t2-link-style" *ngIf="teamData.isPartnerSet()">
            <div [style.background-image]="'url(' + teamData.team.partnerUrls.logo + ')'"
                 (click)="openUrl(teamData.team.partnerUrls.link)"></div>
          </div>

          <!-- Clear float after logo to prevent overlap with menu items -->
          <div style="clear: both;"></div>

          <!-- Basic Mode Setup Button -->
          <ion-item button detail="false" (click)="openSetupPage()"
                    *ngIf="teamData.basicMode"
                    [color]="getBasicBarColor()"
                    class="t2-mode-item">
            <ion-label>{{ 'BASIC_MODE' | translate }}</ion-label>
            <ion-icon name="settings" slot="end"></ion-icon>
          </ion-item>

          <!-- DEBUG: Temporary Setup Button for Testing (uncomment for testing)
          <ion-item button detail="false" (click)="openSetupPage()"
                    *ngIf="!teamData.basicMode"
                    color="warning">
            <ion-icon name="bug" slot="start"></ion-icon>
            <ion-label>Setup (Debug)</ion-label>
          </ion-item>
          -->

          <!-- Navigation Menu Items -->
          <ng-container *ngFor="let page of pages">
            <ion-menu-toggle auto-hide="false" *ngIf="!isMenuHidden(page)">
              <ion-item button detail="false"
                        (click)="openPage(page.title)"
                        [class.t2-menu-active]="page.active"
                        [disabled]="page.basicHide && teamData.basicMode">
                <i class="fa fa-fw fa-{{ page.faIcon }}" slot="start" style="font-size: 25px"></i>
                <ion-label>{{ page.title | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ng-container>

          <!-- Support Link -->
          <ion-menu-toggle auto-hide="false" *ngIf="user.email && !teamData.isSupportHidden()">
            <ion-item button detail="false" (click)="openChat()">
              <i class="fa fa-fw fa-question-circle" slot="start" style="font-size: 25px"></i>
              <ion-label>{{ 'SUPPORT' | translate }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>

    <!-- Main content -->
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>

  <!-- Announcement Footer -->
  <ion-footer *ngIf="showAnnouncement()" class="company-msg-container">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="dismissAnnouncement()">
          <ion-icon name="close-circle"></ion-icon>
        </ion-button>
      </ion-buttons>
      <div class="company-msg-content" [innerHTML]="teamData.metaData.subscriptionData.announcement"></div>
    </ion-toolbar>
  </ion-footer>
</ion-app>
